export const STEP_PX = 3; // N pixels between timeline dot neighbours
export const IMAGE_VIEWER_PREFIX = 'https://aol.mnl.gov.hu';
export const RECORDS_LINK_PREFIX =
	'https://aol.mnl.gov.hu/adatbazis/a-masodik-vilaghaboru-vesztesegi-adatbazisa/kereses?term=';

export const LINK_SVG = `<svg viewBox="64 64 896 896" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z" /></svg>`;

export const FLAG_ICON = `<svg class="info-timeline-flag" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.5 10.5V0.5H8.5L6.38235 2.77848L8.5 5.05696H1.55882" stroke="#F2F2F7"/>
</svg>`;

export const INTENSITY_ICON = `<svg viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="14.4009" cy="14.4009" r="11.8605" stroke="white" stroke-opacity="0.5" stroke-width="0.881471"/>
<path d="M28.8563 14.4277H20.5781" stroke="white" stroke-opacity="0.5" stroke-width="0.881471"/>
<path d="M8.27821 14.4277H0" stroke="white" stroke-opacity="0.5" stroke-width="0.881471"/>
<path d="M14.4297 -0.0008623L14.4297 8.27734" stroke="white" stroke-opacity="0.5" stroke-width="0.881471"/>
<path d="M14.4297 20.5792L14.4297 28.8574" stroke="white" stroke-opacity="0.5" stroke-width="0.881471"/>
<circle cx="14.4687" cy="14.4687" r="2.39836" fill="white" fill-opacity="0.5"/>
<circle cx="14.4687" cy="14.4687" r="1.95762" stroke="white" stroke-opacity="0.5" stroke-width="0.881471"/>
</svg>`;

export const INTENSITY_ICON_ACTIVE = `<svg viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="14.4009" cy="14.4009" r="11.8605" stroke="#FF3C18" stroke-width="0.881471"/>
<path d="M28.8602 14.4277H20.582" stroke="#FF3C18" stroke-width="0.881471"/>
<path d="M8.27821 14.4277H0" stroke="#FF3C18" stroke-width="0.881471"/>
<path d="M14.4297 -0.0008623L14.4297 8.27734" stroke="#FF3C18" stroke-width="0.881471"/>
<path d="M14.4297 20.5792L14.4297 28.8574" stroke="#FF3C18" stroke-width="0.881471"/>
<circle cx="14.4648" cy="14.4687" r="1.95762" fill="#FF3C18" stroke="#FF3C18" stroke-width="0.881471"/>
</svg>`;

export const ROMBUSZ = `<svg viewBox="0 0 108 62" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M53.7508 0.966797L1.68945 30.7761L53.7508 60.5854L105.812 30.7761L53.7508 0.966797Z" stroke="#E0E0E0" stroke-width="1.6794"/>
</svg>`;

export const MANOVEREZO_COLOUR = '#1C6CFF';
export const ALLASHARC_COLOUR = '#000000';

export const TIMELINE_PADDING = 1000 * 60 * 60 * 24 * 7; // 5 days

export const ARROW_PREV = `
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				width="24"
				height="24"
				rx="12"
				fill="white"
				fill-opacity="0.75"
			/>
			<path
				d="M13 8.30859L9 12.3086L13 16.3086"
				stroke="black"
				stroke-linecap="round"
			/>
		</svg>`;

export const ARROW_NEXT = `
					<svg
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							x="24"
							y="24"
							width="24"
							height="24"
							rx="12"
							transform="rotate(-180 24 24)"
							fill="white"
							fill-opacity="0.75"
						/>
						<path
							d="M11 16.3086L15 12.3086L11 8.30859"
							stroke="black"
							stroke-linecap="round"
						/>
					</svg>`;

export const getDateString = (date) =>
	`${date.getFullYear()}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getDate().toString().padStart(2, '0')}.`;
